import generatePicker from "antd/lib/date-picker/generatePicker";
import momentGenerateConfig from "rc-picker/lib/generate/moment";
import { utcNowMoment } from "helpers/utcCalendarDate";

// antd's default "today" is the browser's local day. Calculation dates follow
// the UTC day, including the highlighted cell and the Today / Now button.
const utcCalendarGenerateConfig = {
  ...momentGenerateConfig,
  getNow() {
    return utcNowMoment();
  },
};

const UtcDatePicker = generatePicker(utcCalendarGenerateConfig);

export default UtcDatePicker;
